import { observer } from "mobx-react-lite";
import { FC } from "react";
import { useAppStore } from "@/store";
import { SettingsTemplatesListView } from "@/pages/settings/components/templates/settings-templates-list-view";
import { SettingsTemplatesEditView } from "@/pages/settings/components/templates/settings-templates-edit-view";
import { ShareSheetModal } from "@/components/modal/share-sheet/share-sheet-modal";
import { DeleteTemplateModal } from "@/components/modal/delete-template/delete-template-modal";

export const SettingsTemplatesPage: FC = observer(function SettingsTemplatesPage() {
  const { store } = useAppStore();
  const pageStore = store.settingsModalTemplatesPage;

  return (
    <>
      <ShareSheetModal store={pageStore.shareSheetModal} />
      <DeleteTemplateModal store={pageStore.deleteTemplateModal} />
      {pageStore.subView === "edit" && pageStore.activeTemplate ? (
        <SettingsTemplatesEditView template={pageStore.activeTemplate} pageStore={pageStore} />
      ) : (
        <SettingsTemplatesListView pageStore={pageStore} />
      )}
    </>
  );
});
